"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Compiler = void 0;
const compilation_error_1 = require("./compilation_error");
const parser_1 = require("./parser");
/** Compiles a text renderer */
/* eslint-disable @typescript-eslint/no-explicit-any */
class Compiler {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(formatterBuilders) {
        this.formatterBuilders = formatterBuilders;
        this.parser = new parser_1.Parser();
    }
    compile(template) {
        const parsedTemplate = this.parser.parse(template);
        return this.compileTemplateNode(parsedTemplate);
    }
    compileTemplateNode(token) {
        switch (token.length) {
            case 0:
                return { default: () => '' };
            case 1:
                return this.compileStringPatternNode(token[0]);
            default: {
                const renderers = token.map((subToken) => this.compileStringPatternNode(subToken));
                return { default: (parameters) => renderers.map((renderer) => renderer.default(parameters)).join('') };
            }
        }
    }
    compileStringPatternNode(token) {
        if (typeof token === 'string')
            return { default: () => token };
        const { name, formatters } = token;
        const compiledFormatters = formatters.map((formatter) => this.compileFormatterNode(formatter));
        return {
            default: (parameters) => {
                let result = parameters[name];
                compiledFormatters.forEach((formatter) => {
                    result = formatter.format(result, parameters);
                });
                return result;
            },
        };
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    compileFormatterNode({ name, subTemplates }) {
        const formatterBuilder = this.formatterBuilders[name];
        if (formatterBuilder === undefined)
            throw new compilation_error_1.CompilationError(`Unknown formatter '${name}'`);
        return formatterBuilder(subTemplates.map((subTemplate) => this.compileTemplateNode(subTemplate)));
    }
}
exports.Compiler = Compiler;
//# sourceMappingURL=compiler.js.map